import request from '../request';

const productService = {
  getAll: (params) => request.get('rest/products/paginate', { params }),
  getProductByIds: (params) => request.get('rest/products/ids', { params }),
  getByID: (uuid, params) => request.get(`rest/products/${uuid}`, { params }),
  getBySlug: (slug, params) =>
    request.get(`rest/products/slug/${slug}`, { params }),
  getByCategory: (uuid, params) =>
    request.get(`rest/products/category/${uuid}`, { params }),
  getByBrand: (id, params) =>
    request.get(`rest/products/brand/${id}`, { params }),
  getByShop: (uuid, params) =>
    request.get(`rest/products/shop/${uuid}`, { params }),
  search: (params) =>
    request.get('rest/products/search', { params }),
};

export default productService;
